// Components
import MyImage from '~/components/my-image';
import ViewPublish from '~/components/view-publish';
import VideoSource from '~/components/video-source';
// Utils
import { sec2time } from '~/utils';
// Styles
import styles from './category-post-card.module.scss';

const CategoryPostCard = ({ data, showPublishData = true }) => {
  const {
    title,
    cover_image,
    cover_image_url,
    alt_cover_image,
    created_at,
    duration,
    view_count,
    source = 'youtube',
  } = data;

  return (
    <div className={styles['wrapper']}>
      <div className={styles['wrapper__thumbnail']}>
        <MyImage src={cover_image || cover_image_url} alt={alt_cover_image} />
        {duration > 0 && (
          <div className={styles['wrapper__thumbnail__duration']}>{sec2time(duration)}</div>
        )}
      </div>

      <div className={styles['wrapper__info']}>
        <header className={styles['wrapper__info__title']}>
          <p dangerouslySetInnerHTML={{ __html: title }} />
        </header>

        <ViewPublish viewCount={view_count} publishDate={showPublishData ? created_at : null} />

        <VideoSource source={source} />
      </div>
    </div>
  );
};

export default CategoryPostCard;
